import type { SnoozeFormState } from 'src/admin/common/components/SnoozeModal/types';
import { useForm, useFormState } from 'react-final-form';
import { FC, useCallback } from 'react';
import { SELECTED_LISTING_IDS_FIELD } from 'src/admin/common/components/SnoozeModal/constants';
import Icon from 'src/common/components/IconDS22';
import { useTranslation } from 'next-i18next';
import Checkbox from 'src/common/components/Checkbox';
import LoadingSpinner from 'src/common/components/LoadingSpinner';
import type { MinimalEditorListing } from 'src/common/types/api/listings';
import styles from './BulkList.module.scss';

export type BulkListProps = {
  listings: MinimalEditorListing[];
  loading?: boolean;
};
const BulkList: FC<BulkListProps> = ({
  listings,
  loading,
}) => {
  const { t } = useTranslation('admin-listings');
  const { change } = useForm<SnoozeFormState>();
  const { values: { boats: selectedIds } } = useFormState<SnoozeFormState>();

  const onToggleItem = useCallback((id) => {
    const list = (selectedIds ?? []).slice();
    const index = list.findIndex((boatId) => boatId === id);
    if (index >= 0) {
      list.splice(index, 1);
    } else {
      list.push(id);
    }
    change(SELECTED_LISTING_IDS_FIELD, list);
  }, [selectedIds, change]);

  return (
    <div className={styles.root}>
      <ul role="group" className={styles.list}>
        {listings.map((listing) => (
          <li key={listing.id} className={styles.item}>
            <label className={styles.label}>
              <Checkbox
                checked={selectedIds.includes(listing.id)}
                onChange={() => onToggleItem(listing.id)}
              />
              <span className={styles.labelText}>
                {listing.headline}
              </span>
              {listing.snooze_status != null && <Icon id="moon-filled" />}
            </label>
          </li>
        ))}
        {!loading && listings.length === 0 && (
          <li className={styles.item}>{t('snooze-listing--bulk-selection--empty')}</li>
        )}
        {loading && listings.length === 0 && (
          <li className={styles.loading}>
            <LoadingSpinner variant="xxs" />
            {t('snooze-listing--bulk-selection--loading')}
          </li>
        )}
      </ul>
    </div>
  );
};

export default BulkList;
